<template>
  <!-- 取消预约 -->
  <div>
    <el-row>
      <!-- 工具条 -->
      <el-form :inline="true" :model="formInline" class="demo-form-inline toolbar" style="padding-bottom: 0px"
        @submit.native.prevent>
        <el-form-item label="长者姓名">
          <el-input class="width80" clearable v-model.trim="formInline.oldName" placeholder="请输入长者姓名"
            @keyup.enter.native.prevent="enterSearchMember"></el-input>
        </el-form-item>
        <el-form-item label="所属乡镇:" v-if="areaList.length>0">
          <el-select v-model="formInline.cardAddressList" class="width180" multiple placeholder="请选择">
            <el-option
              v-for="item in areaList"
              :key="item.dictName"
              :label="item.dictName"
              :value="item.dictName">
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="老人类别">
          <el-select class="width80" v-model="formInline.interest" placeholder="请选择">
            <el-option
              v-for="item in personReduceOptions"
              :key="item.id"
              :label="item.userTypeName"
              :value="item.userTypeName"
            ></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="老人类型">
          <el-select class="width80" v-model="formInline.serviceType" placeholder="请选择">
            <el-option label="入院" value="1" ></el-option>
            <el-option label="居家" value="0" ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search" plain>查询</el-button>
          <el-button type="warning" icon="el-icon-plus" @click="addOrder" plain>添加</el-button>
          <el-button type="info" @click="downOldManTemplateByGroup" icon="el-icon-price-tag" plain>模板下载</el-button>
          <el-button type="info" @click="toLead" icon="el-icon-upload" plain>表格导入</el-button>
          <el-button type="info" @click="downLoad" icon="el-icon-document" plain>报表导出</el-button>
          <el-button type="info" v-if="areaList.length>0" @click="downQRCodeLoad" icon="el-icon-crop" plain>二维码导出</el-button>
        </el-form-item>
      </el-form>
      <el-table style="width: 100%" :data="tableData" v-loading="tableLoading" :header-cell-style="{
        'text-align': 'center',
        'font-size': '16px',
        'font-weight': '600',
        color: '#2d2d2d',
        'background-color': '#d4f5fa',
      }" :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :row-style="tableRowStyle">
        <el-table-column prop="oldName" label="长者姓名" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="sex" label="性别" width="70"></el-table-column>
        <el-table-column prop="oldAge" label="年龄" width="70"></el-table-column>
        <el-table-column prop="oldIdCard" label="身份证号" width="190"></el-table-column>
        <el-table-column prop="oldPhone" label="长者电话" width="120"></el-table-column>
        <el-table-column prop="cardAddress" label="街道社区" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="oldAddress" label="家庭住址" min-width="210" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="egNamea" label="紧急联系人" min-width="100"></el-table-column>
        <el-table-column prop="egPhonea" label="联系电话" min-width="110"></el-table-column> -->
        <el-table-column prop="egPhonea" label="老人类型" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.serviceType=='1'" type="success">入院</el-tag>
            <el-tag v-else type="info">居家</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="interest" label="老人类别" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="registryTime" label="登记时间" :formatter="formatTime" min-width="100"></el-table-column>
        <el-table-column label="操作" width="110">
          <template slot-scope="scope">
            <a @click="handleEdit(scope.$index, scope.row)" class="curcor">
              <img class="handedness" src="@/assets/beadhouse/xiugai_icon_1.png" />
            </a>
            <a @click="handleDetail(scope.$index, scope.row)" class="curcor" style="margin-left:12px">
              <img class="handedness" src="@/assets/beadhouse/chakan_icon.png" />
            </a>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="currentPage" layout="total, prev, pager, next" :total="totalDataNumber" :page-size="pageSize"
        align="center" class="fenye">
      </el-pagination>
      <!-- 报表上传 -->
      <el-dialog title="长者表格导入" width="30%" :visible.sync="toLeadVisisble" :close-on-click-modal="false"
        @close="toLeadCloseDialog">
        <el-row type="flex" justify="center">
          <el-col :span="20">
            <el-row>
              <el-col :span="24">
                <input type="file" ref="file" id="file" @change="getUrl" />
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click.native="toLeadVisisble = false">取消</el-button>
          <el-button type="primary" @click.native="intoForm">确定</el-button>
        </div>
      </el-dialog>
    </el-row>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
import { baseURL } from "@/utils/request.js";
export default {
  name: "ResidentManager",
  data() {
    return {
      formInline: {
        oldName: "",
        oldPhone: "",
        serviceType: "",
        interest: "",
        cardAddressList:[],
      },
      areaList:[],
      tableData: [], //表格数据
      tableLoading: false, //表格加载的loading
      /* 分页的 */
      currentPage: 1, //初始页
      toLeadVisisble: false,
      personReduceOptions:[],
      pageNo: 1, //页码
      pageSize: 10, //每页显示的条数
      totalDataNumber: 0, //数据的总数,
      formSelect: [
        {
          label: "男",
          value: "0",
        },
        {
          label: "女",
          value: "1",
        },
      ],
      admissionForm: {
        oldName: "",
        sex: "",
        oldIdCard: "",
        egNamea: "",
        relationshipa: "",
        egaIdCard: "",
        egPhonea: "",
        egaAddress: "",
        oldmanId: "",
      },
      fieldsVisisble: false,
      oldNameOptions: [], // 老人姓名集合
    };
  },
  methods: {
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    formatTime: function (row) {
      if (row.registryTime != null) {
        return row.registryTime;
      } else if(row.createTime != null){
        var date = new Date(row.createTime)
        var Y = date.getFullYear()
        var M = date.getMonth() + 1
        var D = date.getDate()
        return Y + '-' + (M < 10 ? '0' + M : M) + '-' + (D < 10 ? '0' + D : D)
      }else{
        var date = new Date()
        var Y = date.getFullYear();
        var M = date.getMonth() + 1;
        var D = date.getDate();
        return Y + '-' + (M < 10 ? '0' + M : M) + '-' + (D < 10 ? '0' + D : D)
      }
    },
    /*
      添加老人
    */
    addOrder() {
      bus.$emit("homePage", {
        type: "jump",
        path: "/ResidentAdd",
        title: "新增长者信息",
      });
    },
    /*
      点击查询
    */
    search() {
      this.queryOldman(
        this.formInline.oldName,
        this.formInline.interest,
        (this.pageNo = 1),
        (this.pageSize = 10)
      );
    },

    /*
      键盘事件 按下键盘回车 查询
    */
    enterSearchMember(e) {
      // console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13 && this.formInline.oldName != null) {
        this.search();
      }
    },
    handleDetail(index, row) {
      sessionStorage.setItem("oldmanId", row.oldmanId);
      bus.$emit("homePage", {
        type: "jump",
        path: "/ResidentDetail",
        title: "长者档案",
      });

    },
    /*
      修改老人信息
    */
    handleEdit(index, row) {
      console.log(row)
      sessionStorage.setItem("editOldmanId", row.oldmanId);
      bus.$emit("homePage", {
        type: "jump",
        path: "/ResidentAdd",
        title: "编辑长者信息"
      });
    },
    /*
      查询老人分页列表
    */
    queryOldman() {
      // console.log(this.formInline.status == "0");
      let params = {};
      if (this.formInline.oldName != "" || null || undefined) {
        params.oldName = this.formInline.oldName;
      }
      if (this.formInline.interest != "" || null || undefined) {
        params.interest = this.formInline.interest;
      }
      if (this.formInline.sex != "" || null || undefined) {
        params.sex = this.formInline.sex;
      }
      if(this.formInline.cardAddressList!=null && this.formInline.cardAddressList.length>0){
        params.cardAddressList = this.formInline.cardAddressList;
      }
      if (this.formInline.serviceType != "" || null || undefined) {
        params.serviceType = this.formInline.serviceType;
      }
      params.pageNo = String(this.pageNo);
      params.pageSize = String(this.pageSize);
      // params.serviceType = 0;
      this.tableData = [];
      this.tableLoading = true;
      this.$postJson("omc/Oldman/quickShowAllOldMan", params).then((res) => {
        if (res.code == 200) {
          if (res.result.list != null) {
            this.pageSize = res.result.pageSize;
            this.currentPage = res.result.pageNum;
            this.totalDataNumber = res.result.total * 1;
            res.result.list.forEach((item) => {
              var object = {};
              object = Object.assign({}, item);
              object.sex = item.sex == 0 ? "男" : "女";
              this.tableData.push(object);
            });
          } else {
            this.tableData = [];
            this.pageSize = 10;
            this.currentPage = 1;
            this.totalDataNumber = 0;
          }
        } else {
          this.tableData = [];
          this.pageSize = 10;
          this.currentPage = 1;
          this.totalDataNumber = 0;
        }
        this.tableLoading = false;
      });
    },
    /*
      初始页currentPage、初始每页数据数pagesize和数据data
    */
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      //改变每页显示的条数
      this.PageSize = val;
      this.queryOldman(); //刷新套餐列表的数据
    },

    /*
      当前页变化
    */
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.pageNo = val;
      this.queryOldman(); //刷新套餐列表的数据
    },
    downQRCodeLoad(){
      window.location.href =
        baseURL +
        `omc/api/downOldManSqQrcode?groupId=${window.sessionStorage.getItem("groupId")}`;
    },
    //导出
    downLoad() {
      window.location.href =
        baseURL +
        `omc/api/downOldManInformation?groupId=${window.sessionStorage.getItem("groupId")}`;
    },
    // 老人信息模板下载
    downOldManTemplateByGroup() {
      window.location.href = baseURL + `omc/api/downOldManTemplateByShequ`;
    },
    // 上传导入
    toLead() {
      this.toLeadVisisble = true;
    },
    toLeadCloseDialog() {
      this.$refs.file.value = "";
    },
    getUrl(event) {
      let file = event.target.files;
      console.log(file);
      this.fileFlag = true; //by guo 2020-8-4-15:18添加
      this.toLeadForm = new FormData();
      this.toLeadForm.append("file", file[0]);
    },
    // 确认上传
    intoForm() {
      if (this.fileFlag) {
        this.$postFormData("omc/Oldman/toLead", this.toLeadForm).then((res) => {
          this.toLeadVisisble = false;
          this.fileFlag = false;
          this.toLeadForm = {};
          if (res.code == 200) {
            this.$message({ message: res.message, type: "success" });
            this.getAdmissionData();
          } else {
            this.$message({ message: res.message, type: "error" });
          }
        });
      } else {
        this.$message({ message: "请选择文件", type: "error" });
      }
    },
    
    getAreaList(){
      let groupId = window.sessionStorage.getItem("groupId");
      this.$postJson('mdc/dict/queryDictSubListByDictCode/area_' + groupId).then(res=>{
        if(res.result!=null){
          this.areaList = res.result;
        };
      })

      let params = new Object();
      params.pageNum = 0;
      params.pageSize = 0;
      this.personReduceOptions = []; //清空数据，防止累加
      this.$postJson(
        "fmc/elderType/queryList",
        params
      ).then(res => {
        if (res.code == 200) {
          var list = res.result.list || res.result;
          if (list && list.length > 0) {
            list.forEach(item => {
              this.personReduceOptions.push({
                userTypeName: item.userTypeName || item.typeName,
                id: item.id,
              });
            });
          }else{
            this.personReduceOptions.push(
              {
                userTypeName: "普通老人",
                id: "1",
              }
            );
          }
        }
      }).catch(() => {
        this.$postJson("omc/userType/queryListWithPage", params).then(res => {
          if (res.code == 200 && res.result.list && res.result.list.length > 0) {
            res.result.list.forEach(item => {
              this.personReduceOptions.push({
                userTypeName: item.userTypeName,
                id: item.id,
              });
            });
          }
        }).catch(() => {});
      });
    }
  },
  mounted() {
    this.queryOldman();

  },
  computed: {},
  created() {
    this.getAreaList();
    bus.$on("refreshResident", (msg) => {
      this.queryOldman(
        '',
        '',
        (this.pageNo = 1),
        (this.pageSize = 10)
      );
    });
  }
};
</script>
<style lang="scss" scoped>
.toolbar {
  padding-left: 8px;
  padding-top: 5px;
}
.curcor{
  cursor: pointer;
}
::v-deep .el-dialog__header {
  height: 19px !important;
  text-align: left;
}

.width80 {
  width: 160px;
}
.width180 {
  width: 260px;
}
::v-deep .el-dialog__footer {
  text-align: center;
}

.fenye {
  padding: 30px 0;
  margin: 0px auto;
  background: #fff;
}
</style>
  